import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import ThankPage from "./components/ThankPage.jsx";
import ZentorgaRouter from "./zentorga/ZentorgaRouter.jsx";

import Hospital from "./components/Hospital.jsx";
import RandingStyle1 from "./randing/RandingStyle1.jsx";
import RandingStyle2 from "./randing/RandingStyle2.jsx";
import Policy from "./pages/policy/Policy.jsx";
import Randing001 from "./pages/023/Randing001.jsx";
import Randing002 from "./pages/025/Randing002.jsx";
import Randing003 from "./pages/025/Randing003.jsx";
import Randing004 from "./pages/017/Randing004.jsx";
import Randing005 from "./pages/023/Randing005.jsx";
import Randing006 from "./pages/023/Randing006.jsx";
import Randing007 from "./pages/023/Randing007.jsx";
import Randing008 from "./pages/025/Randing008.jsx";
import Randing009 from "./pages/023/Randing009.jsx";
import Randing010 from "./pages/026/Randing010.jsx";
import Randing011 from "./pages/026/Randing011.jsx";
import Randing024 from "./pages/013/Randing024.jsx";
import Randing023 from "./pages/044/Randing023.jsx";
import Randing022 from "./pages/012/Randing022.jsx";
import Randing021 from "./pages/013/Randing021.jsx";
import Randing020 from "./pages/044/Randing020.jsx";
import Randing019 from "./pages/015/Randing019.jsx";
import Randing018 from "./pages/012/Randing018.jsx";
import Randing017 from "./pages/002/Randing017.jsx";
import Randing016 from "./pages/002/Randing016.jsx";
import Randing015 from "./pages/027/Randing015.jsx";
import Randing014 from "./pages/023/Randing014.jsx";
import Randing013 from "./pages/023/Randing013.jsx";
import Randing012 from "./pages/023/Randing012.jsx";
// import Randing999 from "./randing/Randing999.jsx";
import Randing026 from "./pages/027/Randing026.jsx";
import Randing025 from "./pages/025/Randing025.jsx";
import Randing027 from "./pages/003/Randing027.jsx";
import Randing028 from "./pages/003/Randing028.jsx";
import Randing029 from "./pages/006/Randing029.jsx";
import Randing030 from "./pages/003/Randing030.jsx";
import Randing031 from "./pages/003/Randing031.jsx";
import Randing032 from "./pages/014/Randing032.jsx";
import Randing033 from "./pages/003/Randing033.jsx";
import Randing034 from "./pages/004/Randing034.jsx";

import Randing038 from "./pages/006/Randing038.jsx";
import Randing037 from "./pages/004/Randing037.jsx";
import Randing035 from "./pages/025/Randing035.jsx";
import Randing039 from "./pages/017/Randing039.jsx";
import Randing040 from "./pages/003/Randing040.jsx";
import Randing041 from "./pages/014/Randing041.jsx";

import Randing042 from "./pages/002/Randing042.jsx";
import Randing043 from "./pages/002/Randing043.jsx";
import Randing044 from "./pages/002/Randing044.jsx";
import Randing045 from "./pages/001/Randing045.jsx";
import Randing046 from "./pages/028/Randing046.jsx";
import Randing047 from "./pages/029/Randing047.jsx";
import Randing048 from "./pages/002/Randing048.jsx";
import Randing049 from "./pages/017/Randing049.jsx";
import Randing050 from "./pages/023/Randing050.jsx";
import Randing051 from "./pages/006/Randing051.jsx";
import Randing052 from "./pages/002/Randing052.jsx";
import Randing053 from "./pages/002/Randing053.jsx";
import Randing054 from "./pages/002/Randing054.jsx";
import Randing055 from "./pages/002/Randing055.jsx";
import Randing056 from "./pages/002/Randing056.jsx";
import Randing057 from "./pages/002/Randing057.jsx";
import Randing058 from "./pages/006/Randing058.jsx";
import Randing059 from "./pages/001/Randing059.jsx";
import Randing060 from "./pages/002/Randing060.jsx";
import Randing061 from "./pages/014/Randing061.jsx";
import Randing062 from "./pages/017/Randing062.jsx";
import Randing063 from "./pages/001/Randing063.jsx";
import Randing064 from "./pages/023/Randing064.jsx";
import Randing065 from "./pages/030/Randing065.jsx";
import Randing066 from "./pages/030/Randing066.jsx";
import Randing067 from "./pages/002/Randing067.jsx";
import Randing068 from "./pages/004/Randing068.jsx";
import Randing069 from "./pages/011/Randing069.jsx";
import Randing070 from "./pages/028/Randing070.jsx";
import Randing071 from "./pages/001/Randing071.jsx";
import Randing072 from "./pages/004/Randing072.jsx";
import Randing073 from "./pages/002/Randing073.jsx";
import Randing074 from "./pages/017/Randing074.jsx";
import Randing075 from "./pages/028/Randing075.jsx";
import Randing076 from "./pages/023/Randing076.jsx";
import Randing077 from "./pages/017/Randing077.jsx";
import Randing078 from "./pages/044/Randing078.jsx";
import Randing079 from "./pages/014/Randing079.jsx";
import Randing080 from "./pages/023/Randing080.jsx";
import Randing081 from "./pages/002/Randing081.jsx";
import Randing082 from "./pages/030/Randing082.jsx";
import Randing083 from "./pages/028/Randing083.jsx";
import Randing084 from "./pages/023/Randing084.jsx";
import Randing085 from "./pages/031/Randing085.jsx";
import Randing086 from "./pages/001/Randing086.jsx";
import Randing087 from "./pages/017/Randing087.jsx";
import Randing088 from "./pages/031/Randing088.jsx";
import Randing089 from "./pages/030/Randing089.jsx";
import Randing090 from "./pages/006/Randing090.jsx";
import Randing091 from "./pages/002/Randing091.jsx";
import Randing092 from "./pages/023/Randing092.jsx";
import Randing093 from "./pages/001/Randing093.jsx";
import Randing094 from "./pages/002/Randing094.jsx";
import Randing095 from "./pages/030/Randing095.jsx";
import Randing096 from "./pages/002/Randing096.jsx";
import Randing097 from "./pages/044/Randing097.jsx";
import Randing098 from "./pages/030/Randing098.jsx";
import Randing099 from "./pages/002/Randing099.jsx";
import Randing100 from "./pages/017/Randing100.jsx";
import Randing101 from "./pages/001/Randing101.jsx";
import Randing102 from "./pages/032/Randing102.jsx";
import Randing103 from "./pages/002/Randing103.jsx";
import Randing104 from "./pages/002/Randing104.jsx";
import Randing105 from "./pages/002/Randing105.jsx";
import Randing106 from "./pages/017/Randing106.jsx";
import Randing107 from "./pages/028/Randing107.jsx";
import Randing108 from "./pages/002/Randing108.jsx";
import Randing109 from "./pages/004/Randing109.jsx";
import Randing110 from "./pages/023/Randing110.jsx";
import Randing111 from "./pages/023/Randing111.jsx";
import Randing112 from "./pages/014/Randing112.jsx";
import Randing113 from "./pages/001/Randing113.jsx";
import Randing114 from "./pages/003/Randing114.jsx";
import Randing115 from "./pages/004/Randing115.jsx";
import Randing116 from "./pages/001/Randing116.jsx";
import Randing117 from "./pages/025/Randing117.jsx";
import Randing118 from "./pages/033/Randing118.jsx";
import Randing119 from "./pages/028/Randing119.jsx";
import TAX_cop_1 from "./tax/TAX_cop_1.jsx";
import Randing120 from "./pages/004/Randing120.jsx";
import Randing121 from "./pages/014/Randing121.jsx";
import Taxend from "./components/Taxend.jsx";
import Randing122 from "./pages/002/Randing122.jsx";
import Randing123 from "./pages/002/Randing123.jsx";
import Randing124 from "./pages/023/Randing124.jsx";
import Randing125 from "./pages/023/Randing125.jsx";
import Randing126 from "./pages/025/Randing126.jsx";
import Randing127 from "./pages/001/Randing127.jsx";
import Randing128 from "./pages/004/Randing128.jsx";
import Randing129 from "./pages/003/Randing129.jsx";
import Randing130 from "./pages/002/Randing130.jsx";
import Randing131 from "./pages/034/Randing131.jsx";
import Randing132 from "./pages/044/Randing132.jsx";
import Randing133 from "./pages/003/Randing133.jsx";
import Randing135 from "./pages/001/Randing135.jsx";
import Randing136 from "./pages/014/Randing136.jsx";
import Randing137 from "./pages/028/Randing137.jsx";
import Randing138 from "./pages/044/Randing138.jsx";
import Randing139 from "./pages/017/Randing139.jsx";
import Randing140 from "./pages/017/Randing140.jsx";
import Randing141 from "./pages/001/Randing141.jsx";
import Randing142 from "./pages/001/Randing142.jsx";
import Randing143 from "./pages/017/Randing143.jsx";
import Randing144 from "./pages/017/Randing144.jsx";
import Randing145 from "./pages/025/Randing145.jsx";
import Randing146 from "./pages/023/Randing146.jsx";
import Randing147 from "./pages/002/Randing147.jsx";
import Randing148 from "./pages/023/Randing148.jsx";
import Randing149 from "./pages/012/Randing149.jsx";
import Randing150 from "./pages/012/Randing150.jsx";
import Randing151 from "./pages/035/Randing151.jsx";
import Randing152 from "./pages/001/Randing152.jsx";
import Randing153 from "./pages/028/Randing153.jsx";
import Randing154 from "./pages/025/Randing154.jsx";
import Randing155 from "./pages/027/Randing155.jsx";
import Randing156 from "./pages/001/Randing156.jsx";
import Randing157 from "./pages/034/Randing157.jsx";
import Randing158 from "./pages/035/Randing158.jsx";
import Randing159 from "./pages/002/Randing159.jsx";
import Randing160 from "./pages/001/Randing160.jsx";
import Randing161 from "./pages/023/Randing161.jsx";
import Randing162 from "./pages/003/Randing162.jsx";
import Randing163 from "./pages/035/Randing163.jsx";
import Randing164 from "./pages/004/Randing164.jsx";
import Randing165 from "./pages/014/Randing165.jsx";
import Randing166 from "./pages/036/Randing166.jsx";
import Randing500 from "./pages/036/Randing500.jsx";
import Randing167 from "./pages/035/Randing167.jsx";
import Randing168 from "./pages/034/Randing168.jsx";
import Randing169 from "./pages/001/Randing169.jsx";
import Randing170 from "./pages/014/Randing170.jsx";
import Randing171 from "./pages/023/Randing171.jsx";
import Randing172 from "./pages/025/Randing172.jsx";
import Randing173 from "./pages/002/Randing173.jsx";
import Randing174 from "./pages/002/Randing174.jsx";
import Randing175 from "./pages/023/Randing175.jsx";
import Randing176 from "./pages/012/Randing176.jsx";
import Randing177 from "./pages/044/Randing177.jsx";
import Randing178 from "./pages/017/Randing178.jsx";
import Randing179 from "./pages/032/Randing179.jsx";
import Randing180 from "./pages/002/Randing180.jsx";
import Randing181 from "./pages/027/Randing181.jsx";
import Randing182 from "./pages/044/Randing182.jsx";
import Randing183 from "./pages/025/Randing183.jsx";
import Randing184 from "./pages/002/Randing184.jsx";
import Randing185 from "./pages/002/Randing185.jsx";
import Randing186 from "./pages/002/Randing186.jsx";
import Randing188 from "./pages/033/Randing188.jsx";
import Randing189 from "./pages/017/Randing189.jsx";
import Randing191 from "./pages/001/Randing191.jsx";
import Randing190 from "./pages/023/Randing190.jsx";
import Randing192 from "./pages/023/Randing192.jsx";
import Randing193 from "./pages/035/Randing193.jsx";
import Randing194 from "./pages/002/Randing194.jsx";
import Randing195 from "./pages/044/Randing195.jsx";
import Randing196 from "./pages/004/Randing196.jsx";
import Randing197 from "./pages/001/Randing197.jsx";
import Randing198 from "./pages/012/Randing198.jsx";
import Randing199 from "./pages/004/Randing199.jsx";
import Randing200 from "./pages/004/Randing200.jsx";
import Randing201 from "./pages/004/Randing201.jsx";
import Randing203 from "./pages/017/Randing203.jsx";
import Randing205 from "./pages/032/Randing205.jsx";
import Randing206 from "./pages/032/Randing206.jsx";
import Randing207 from "./pages/012/Randing207.jsx";
import Randing208 from "./pages/014/Randing208.jsx";
import Randing209 from "./pages/014/Randing209.jsx";
import Randing211 from "./pages/035/Randing211.jsx";
import Randing210 from "./pages/034/Randing210.jsx";
import Randing212 from "./pages/025/Randing212.jsx";
import Randing213 from "./pages/044/Randing213.jsx";
import Randing215 from "./pages/044/Randing215.jsx";
import Randing217 from "./pages/044/Randing217.jsx";
import Randing218 from "./pages/017/Randing218.jsx";
import Randing220 from "./pages/023/Randing220.jsx";
import Randing221 from "./pages/044/Randing221.jsx";
import Randing222 from "./pages/002/Randing222.jsx";
import Randing223 from "./pages/017/Randing223.jsx";
import Randing224 from "./pages/001/Randing224.jsx";
import Randing225 from "./pages/034/Randing225.jsx";
import Randing226 from "./pages/001/Randing226.jsx";
import Randing227 from "./pages/002/Randing227.jsx";
import Randing228 from "./pages/025/Randing228.jsx";
import Randing229 from "./pages/035/Randing229.jsx";
import Randing230 from "./pages/032/Randing230.jsx";
import Randing231 from "./pages/028/Randing231.jsx";
import Randing232 from "./pages/017/Randing232.jsx";
import Randing233 from "./pages/017/Randing233.jsx";
import Randing234 from "./pages/032/Randing234.jsx";
import Randing236 from "./pages/017/Randing236.jsx";
import Randing237 from "./pages/025/Randing237.jsx";
import Randing238 from "./pages/001/Randing238.jsx";
import NotFound from "./pages/NotFound.jsx";
import Randing239 from "./pages/027/Randing239.jsx";
import Randing240 from "./pages/032/Randing240.jsx";
import Randing242 from "./pages/001/Randing242.jsx";
import Randing244 from "./pages/023/Randing233.jsx";
import Randing245 from "./pages/012/Randing245.jsx";
import Randing246 from "./pages/034/Randing246.jsx";
import Randing247 from "./pages/014/Randing247.jsx";
import Randing249 from "./pages/003/Randing249.jsx";
import Randing248 from "./pages/003/Randing248.jsx";
import Randing250 from "./pages/003/Randing250.jsx";
import Randing251 from "./pages/003/Randing251.jsx";
import Randing254 from "./pages/027/Randing254.jsx";
import Randing256 from "./pages/025/Randing256.jsx";
import Randing257 from "./pages/035/Randing257.jsx";
import Randing258 from "./pages/035/Randing258.jsx";
import Randing259 from "./pages/032/Randing259.jsx";
import Randing260 from "./pages/032/Randing260.jsx";
import Randing261 from "./pages/017/Randing261.jsx";
import Randing262 from "./pages/027/Randing262.jsx";
import Randing280 from "./pages/001/Randing280.jsx";
import Randing283 from "./pages/032/Randing283.jsx";
import Randing284 from "./pages/028/Randing284.jsx";
import Randing285 from "./pages/028/Randing285.jsx";
import Randing286 from "./pages/035/Randing286.jsx";
import Randing287 from "./pages/017/Randing287.jsx";
import Randing288 from "./pages/044/Randing288.jsx";
import Randing289 from "./pages/027/Randing289.jsx";
import Randing290 from "./pages/027/Randing290.jsx";
import Randing291 from "./pages/023/Randing291.jsx";
import Randing292 from "./pages/035/Randing292.jsx";
import Randing293 from "./pages/004/Randing293.jsx";
import Randing295 from "./pages/034/Randing295.jsx";
import Randing296 from "./pages/028/Randing296.jsx";
import Randing299 from "./pages/028/Randing299.jsx";
import Randing317 from "./pages/028/Randing317.jsx";
import Randing318 from "./pages/028/Randing318.jsx";
import Randing340 from "./pages/028/Randing340.jsx";
import Randing345 from "./pages/028/Randing345.jsx";
import Randing346 from "./pages/001/Randing346.jsx";
import Randing347 from "./pages/028/Randing347.jsx";
import Randing367 from "./pages/001/Randing367.jsx";
import Randing473 from "./pages/003/Randing473.jsx";
import Randing485 from "./pages/048/Randing485.jsx";
import Randing486 from "./pages/045/Randing486.jsx";
import Randing487 from "./pages/005/Randing487.jsx";
import Randing490 from "./pages/001/Randing490.jsx";
import Randing508 from "./pages/001/Randing508.jsx";
import Randing511 from "./pages/001/Randing511.jsx";
import Randing515 from "./pages/001/Randing515.jsx";
import Randing523 from "./pages/005/Randing523.jsx";
import Randing543 from "./pages/005/Randing543.jsx";
import Randing576 from "./pages/001/Randing576.jsx";
import Randing577 from "./pages/001/Randing577.jsx";
import Randing579 from "./pages/005/Randing579.jsx";
import Randing535 from "./pages/023/Randing535.jsx";
import Randing539 from "./pages/001/Randing539.jsx";
import Randing540 from "./pages/001/Randing540.jsx";
import Randing585 from "./randing585/Randing585.jsx";

// selectedValue = "복수 이벤트"

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route
            path="/:hospitalNumber/:adnumber/:urlCode"
            element={<Hospital />}
          />
          <Route path="/" element={<Hospital />} />
          <Route path="/tax/cop/1" element={<TAX_cop_1 />} />
          <Route path="/taxend" element={<Taxend />} />
          <Route path="/thanks" element={<ThankPage />} />
          <Route path="/policy1" element={<Policy policyName="본원" />} />
          <Route path="/policy2" element={<Policy policyName="본원" />} />
          {/* 스타일1 */}
          <Route path="/001" element={<Randing001 />} />
          <Route path="/002" element={<Randing002 />} />
          <Route path="/009" element={<Randing009 />} />
          <Route path="/012" element={<Randing012 />} />
          <Route path="/017" element={<Randing017 />} />
          <Route path="/018" element={<Randing018 />} />
          <Route path="/019" element={<Randing019 />} />
          <Route path="/020" element={<Randing020 />} />
          <Route path="/021" element={<Randing021 />} />
          <Route path="/022" element={<Randing022 />} />
          <Route path="/023" element={<Randing023 />} />
          <Route path="/024" element={<Randing024 />} />
          <Route path="/025" element={<Randing025 />} />
          <Route path="/039" element={<Randing039 />} />
          <Route path="/041" element={<Randing041 />} />
          <Route path="/047" element={<Randing047 />} />
          <Route path="/054" element={<Randing054 />} />
          <Route path="/056" element={<Randing056 />} />
          <Route path="/061" element={<Randing061 />} />
          <Route path="/065" element={<Randing065 />} />
          <Route path="/066" element={<Randing066 />} />
          <Route path="/069" element={<Randing069 />} />
          <Route path="/088" element={<Randing088 />} />
          <Route path="/168" element={<Randing168 />} />
          <Route path="/207" element={<Randing207 />} />
          <Route path="/211" element={<Randing211 />} />
          <Route path="/215" element={<Randing215 />} />
          <Route path="/217" element={<Randing217 />} />
          <Route path="/257" element={<Randing257 />} />
          {/* <Route path="/999" element={<A999 />} /> */}
          {/* 스타일4*/}
          <Route path="/003" element={<Randing003 />} />
          <Route path="/008" element={<Randing008 />} />
          <Route path="/010" element={<Randing010 />} />
          <Route path="/011" element={<Randing011 />} />
          <Route path="/026" element={<Randing026 />} />
          <Route path="/032" element={<Randing032 />} />
          <Route path="/035" element={<Randing035 />} />
          <Route path="/037" element={<Randing037 />} />
          <Route path="/038" element={<Randing038 />} />
          <Route path="/043" element={<Randing043 />} />
          <Route path="/044" element={<Randing044 />} />
          <Route path="/050" element={<Randing050 />} />
          <Route path="/059" element={<Randing059 />} />
          <Route path="/060" element={<Randing060 />} />
          <Route path="/070" element={<Randing070 />} />
          <Route path="/075" element={<Randing075 />} />
          <Route path="/083" element={<Randing083 />} />
          <Route path="/084" element={<Randing084 />} />
          <Route path="/086" element={<Randing086 />} />
          <Route path="/085" element={<Randing085 />} />
          <Route path="/087" element={<Randing087 />} />
          <Route path="/089" element={<Randing089 />} />
          <Route path="/092" element={<Randing092 />} />
          <Route path="/111" element={<Randing111 />} />
          <Route path="/112" element={<Randing112 />} />
          <Route path="/116" element={<Randing116 />} />
          <Route path="/117" element={<Randing117 />} />
          <Route path="/119" element={<Randing119 />} />
          <Route path="/130" element={<Randing130 />} />
          <Route path="/137" element={<Randing137 />} />
          <Route path="/144" element={<Randing144 />} />
          <Route path="/153" element={<Randing153 />} />
          <Route path="/156" element={<Randing156 />} />
          <Route path="/159" element={<Randing159 />} />
          <Route path="/170" element={<Randing170 />} />
          <Route path="/171" element={<Randing171 />} />
          <Route path="/172" element={<Randing172 />} />
          <Route path="/173" element={<Randing173 />} />
          <Route path="/174" element={<Randing174 />} />
          <Route path="/181" element={<Randing181 />} />
          <Route path="/182" element={<Randing182 />} />
          <Route path="/197" element={<Randing197 />} />
          <Route path="/198" element={<Randing198 />} />
          <Route path="/208" element={<Randing208 />} />
          <Route path="/222" element={<Randing222 />} />
          <Route path="/231" element={<Randing231 />} />
          <Route path="/242" element={<Randing242 />} />
          <Route path="/248" element={<Randing248 />} />
          <Route path="/280" element={<Randing280 />} />
          <Route path="/285" element={<Randing285 />} />
          {/* 스타일6 */}
          <Route path="/005" element={<Randing005 />} />
          <Route path="/015" element={<Randing015 />} />
          <Route path="/027" element={<Randing027 />} />
          <Route path="/028" element={<Randing028 />} />
          <Route path="/030" element={<Randing030 />} />
          <Route path="/052" element={<Randing052 />} />
          <Route path="/068" element={<Randing068 />} />
          <Route path="/078" element={<Randing078 />} />
          <Route path="/095" element={<Randing095 />} />
          <Route path="/102" element={<Randing102 />} />
          <Route path="/108" element={<Randing108 />} />
          <Route path="/114" element={<Randing114 />} />
          <Route path="/118" element={<Randing118 />} />
          <Route path="/128" element={<Randing128 />} />
          <Route path="/133" element={<Randing133 />} />
          <Route path="/188" element={<Randing188 />} />
          <Route path="/246" element={<Randing246 />} />
          {/* 스타일7 */}
          <Route path="/016" element={<Randing016 />} />
          <Route path="/057" element={<Randing057 />} />
          <Route path="/063" element={<Randing063 />} />
          <Route path="/192" element={<Randing192 />} />
          <Route path="/224" element={<Randing224 />} />
          {/* 스타일8 */}
          {/* <Route path="/006" element={<Randing006 />} /> */}
          {/* 스타일9 */}
          {/* <Route path="/007" element={<Randing007 />} /> */}
          {/* <Route path="/045" element={<Randing045 />} /> */}
          <Route path="/053" element={<Randing053 />} />
          {/* <Route path="/093" element={<Randing093 />} /> */}
          {/* <Route path="/101" element={<Randing101 />} /> */}
          {/* <Route path="/167" element={<Randing167 />} /> */}
          {/* <Route path="/193" element={<Randing193 />} /> */}
          {/* <Route path="/205" element={<Randing205 />} /> */}
          {/* <Route path="/206" element={<Randing206 />} /> */}
          {/* <Route path="/229" element={<Randing229 />} /> */}
          <Route path="/240" element={<Randing240 />} />
          {/* <Route path="/258" element={<Randing258 />} /> */}
          {/* <Route path="/259" element={<Randing259 />} /> */}
          {/* <Route path="/260" element={<Randing260 />} /> */}
          <Route path="/292" element={<Randing292 />} />
          <Route path="/346" element={<Randing346 />} />
          <Route path="/367" element={<Randing367 />} />

          {/* 스타일10 */}
          {/* <Route path="/013" element={<Randing013 />} /> */}
          {/* <Route path="/014" element={<Randing014 />} /> */}
          {/* <Route path="/029" element={<Randing029 />} /> */}
          {/* <Route path="/049" element={<Randing049 />} /> */}
          {/* <Route path="/051" element={<Randing051 />} /> */}
          <Route path="/055" element={<Randing055 />} />
          {/* <Route path="/058" element={<Randing058 />} /> */}
          {/* <Route path="/062" element={<Randing062 />} /> */}
          {/* <Route path="/064" element={<Randing064 />} /> */}
          <Route path="/067" element={<Randing067 />} />
          {/* <Route path="/073" element={<Randing073 />} /> */}
          {/* <Route path="/074" element={<Randing074 />} /> */}
          {/* <Route path="/076" element={<Randing076 />} /> */}
          {/* <Route path="/079" element={<Randing079 />} /> */}
          {/* <Route path="/080" element={<Randing080 />} /> */}
          {/* <Route path="/081" element={<Randing081 />} /> */}
          {/* <Route path="/082" element={<Randing082 />} /> */}
          {/* <Route path="/090" element={<Randing090 />} /> */}
          {/* <Route path="/096" element={<Randing096 />} /> */}
          {/* <Route path="/097" element={<Randing097 />} /> */}
          {/* <Route path="/098" element={<Randing098 />} /> */}
          {/* <Route path="/103" element={<Randing103 />} /> */}
          {/* <Route path="/104" element={<Randing104 />} /> */}
          <Route path="/105" element={<Randing105 />} />
          {/* <Route path="/106" element={<Randing106 />} /> */}
          <Route path="/109" element={<Randing109 />} />
          {/* <Route path="/110" element={<Randing110 />} /> */}
          {/* <Route path="/115" element={<Randing115 />} /> */}
          {/* <Route path="/120" element={<Randing120 />} /> */}
          {/* <Route path="/121" element={<Randing121 />} /> */}
          <Route path="/122" element={<Randing122 />} />
          <Route path="/123" element={<Randing123 />} />
          {/* <Route path="/124" element={<Randing124 />} /> */}
          {/* <Route path="/125" element={<Randing125 />} /> */}
          <Route path="/126" element={<Randing126 />} />
          {/* <Route path="/129" element={<Randing129 />} /> */}
          {/* <Route path="/131" element={<Randing131 />} /> */}
          {/* <Route path="/132" element={<Randing132 />} /> */}
          {/* <Route path="/136" element={<Randing136 />} /> */}
          <Route path="/138" element={<Randing138 />} />
          {/* <Route path="/139" element={<Randing139 />} /> */}
          {/* <Route path="/140" element={<Randing140 />} /> */}
          {/* <Route path="/145" element={<Randing145 />} /> */}
          {/* <Route path="/149" element={<Randing149 />} /> */}
          {/* <Route path="/150" element={<Randing150 />} /> */}
          {/* <Route path="/151" element={<Randing151 />} /> */}
          {/* <Route path="/155" element={<Randing155 />} /> */}
          {/* <Route path="/157" element={<Randing157 />} /> */}
          {/* <Route path="/158" element={<Randing158 />} /> */}
          {/* <Route path="/161" element={<Randing161 />} /> */}
          {/* <Route path="/162" element={<Randing162 />} /> */}
          {/* <Route path="/163" element={<Randing163 />} /> */}
          {/* <Route path="/164" element={<Randing164 />} /> */}
          {/* <Route path="/175" element={<Randing175 />} /> */}
          {/* <Route path="/176" element={<Randing176 />} /> */}
          <Route path="/178" element={<Randing178 />} />
          {/* <Route path="/179" element={<Randing179 />} /> */}
          {/* <Route path="/180" element={<Randing180 />} /> */}
          <Route path="/183" element={<Randing183 />} />
          {/* <Route path="/184" element={<Randing184 />} /> */}
          {/* <Route path="/185" element={<Randing185 />} /> */}
          {/* <Route path="/186" element={<Randing186 />} /> */}
          <Route path="/189" element={<Randing189 />} />
          {/* <Route path="/190" element={<Randing190 />} /> */}
          {/* <Route path="/191" element={<Randing191 />} /> */}
          {/* <Route path="/194" element={<Randing194 />} /> */}
          {/* <Route path="/195" element={<Randing195 />} /> */}
          {/* <Route path="/196" element={<Randing196 />} /> */}
          <Route path="/199" element={<Randing199 />} />
          <Route path="/200" element={<Randing200 />} />
          <Route path="/201" element={<Randing201 />} />
          <Route path="/209" element={<Randing209 />} />
          <Route path="/210" element={<Randing210 />} />
          <Route path="/212" element={<Randing212 />} />
          <Route path="/213" element={<Randing213 />} />
          <Route path="/218" element={<Randing218 />} />
          <Route path="/223" element={<Randing223 />} />
          <Route path="/225" element={<Randing225 />} />
          <Route path="/227" element={<Randing227 />} />
          <Route path="/228" element={<Randing228 />} />
          <Route path="/230" element={<Randing230 />} />
          <Route path="/232" element={<Randing232 />} />
          <Route path="/234" element={<Randing234 />} />
          <Route path="/236" element={<Randing236 />} />
          <Route path="/237" element={<Randing237 />} />
          <Route path="/239" element={<Randing239 />} />
          <Route path="/247" element={<Randing247 />} />
          <Route path="/249" element={<Randing249 />} />
          <Route path="/251" element={<Randing251 />} />
          <Route path="/254" element={<Randing254 />} />
          <Route path="/256" element={<Randing256 />} />
          <Route path="/261" element={<Randing261 />} />
          {/* 스타일11 */}
          {/* <Route path="/031" element={<Randing031 />} /> */}
          {/* <Route path="/033" element={<Randing033 />} /> */}
          {/* <Route path="/040" element={<Randing040 />} /> */}
          <Route path="/071" element={<Randing071 />} />
          {/* 스타일12 */}
          {/* <Route path="/127" element={<Randing127 />} /> */}
          {/* <Route path="/135" element={<Randing135 />} /> */}
          <Route path="/141" element={<Randing141 />} />
          {/* <Route path="/142" element={<Randing142 />} /> */}
          <Route path="/152" element={<Randing152 />} />
          {/* <Route path="/160" element={<Randing160 />} /> */}
          <Route path="/169" element={<Randing169 />} />
          <Route path="/226" element={<Randing226 />} />
          <Route path="/238" element={<Randing238 />} />
          {/* 스타일13 */}
          <Route path="/042" element={<Randing042 />} />

          {/* 스타일14 */}
          <Route path="/046" element={<Randing046 />} />
          <Route path="/107" element={<Randing107 />} />
          <Route path="/318" element={<Randing318 />} />

          {/* 스타일15 */}
          <Route path="/048" element={<Randing048 />} />

          {/* 스타일16 */}
          {/* <Route path="/034" element={<Randing034 />} /> */}
          {/* <Route path="/054" element={<Randing054 />} /> */}
          {/* <Route path="/072" element={<Randing072 />} /> */}
          <Route path="/091" element={<Randing091 />} />
          <Route path="/113" element={<Randing113 />} />

          {/* 스타일17 */}
          <Route path="/077" element={<Randing077 />} />
          <Route path="/094" element={<Randing094 />} />

          {/* 스타일18 */}
          <Route path="/099" element={<Randing099 />} />
          <Route path="/100" element={<Randing100 />} />

          {/* 스타일19 */}
          <Route path="/143" element={<Randing143 />} />
          {/* <Route path="/146" element={<Randing146 />} /> */}
          {/* <Route path="/147" element={<Randing147 />} /> */}
          {/* <Route path="/148" element={<Randing148 />} /> */}
          {/* <Route path="/154" element={<Randing154 />} /> */}
          {/* <Route path="/165" element={<Randing165 />} /> */}
          <Route path="/166" element={<Randing166 />} />
          <Route path="/177" element={<Randing177 />} />

          {/* 스타일20 */}
          <Route path="/203" element={<Randing203 />} />
          <Route path="/220" element={<Randing220 />} />
          <Route path="/221" element={<Randing221 />} />

          {/* 스타일21 */}
          <Route path="/233" element={<Randing233 />} />
          <Route path="/244" element={<Randing244 />} />
          <Route path="/245" element={<Randing245 />} />
          <Route path="/250" element={<Randing250 />} />

          {/* 스타일22 */}
          {/* <Route path="/262" element={<Randing262 />} /> */}
          {/* <Route path="/286" element={<Randing286 />} /> */}
          {/* <Route path="/287" element={<Randing287 />} /> */}
          <Route path="/288" element={<Randing288 />} />
          <Route path="/289" element={<Randing289 />} />
          <Route path="/290" element={<Randing290 />} />
          <Route path="/291" element={<Randing291 />} />
          <Route path="/293" element={<Randing293 />} />
          <Route path="/295" element={<Randing295 />} />

          {/* 스타일23 */}
          <Route path="/283" element={<Randing283 />} />

          {/* 스타일24 */}
          <Route path="/284" element={<Randing284 />} />

          {/* 스타일25 */}
          <Route path="/296" element={<Randing296 />} />
          <Route path="/299" element={<Randing299 />} />
          <Route path="/317" element={<Randing317 />} />
          <Route path="/340" element={<Randing340 />} />
          <Route path="/345" element={<Randing345 />} />
          <Route path="/347" element={<Randing347 />} />

          {/* 스타일25 */}
          <Route path="/473" element={<Randing473 />} />
          {/* Zentorga dynamic routes - must be last to avoid conflicts */}

          {/* 스타일27 */}
          <Route path="/485" element={<Randing485 />} />
          <Route path="/486" element={<Randing486 />} />
          <Route path="/487" element={<Randing487 />} />
          <Route path="/508" element={<Randing508 />} />
          <Route path="/511" element={<Randing511 />} />
          <Route path="/515" element={<Randing515 />} />
          <Route path="/523" element={<Randing523 />} />
          <Route path="/543" element={<Randing543 />} />
          <Route path="/576" element={<Randing576 />} />
          <Route path="/577" element={<Randing577 />} />
          <Route path="/579" element={<Randing579 />} />
          <Route path="/535" element={<Randing535 />} />


          <Route path="/539" element={<Randing539 />} />
          <Route path="/540" element={<Randing540 />} />

          <Route path="/585" element={<Randing585 />} />
          <Route path="/585/:urlCode" element={<Randing585 />} />
          <Route path="/000/585/:urlCode" element={<Randing585 />} />

          <Route path="/:adNumber/:code" element={<ZentorgaRouter />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
